import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import { useTranslation } from 'react-i18next';

import './NotYou.scss';

/**
 * @component
 * @description Component that shows the user where they are logging into and what email they are using.
 * Allows the user to reset that data.
 * @returns {JSX.Element} React component
 */
export const NotYou = ({
  header,
  emailPrefix,
  email,
  name,
  onResetClick,
}: {
  header?: string;
  email: string;
  emailPrefix?: string;
  name?: string | null;
  onResetClick: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="information">
      {header && <p className="information__header">{header}</p>}
      <p className="information__sub-line" data-testid="not-you">
        {emailPrefix || t('You are signing in as ')}
        <span className="information__email">{email}</span>
      </p>
      {name && (
        <p className="information__sub-line">
          <span className="information__email">{name}</span>
        </p>
      )}
      <OpButton type="link" onClick={onResetClick}>
        {t('Not you?')}
      </OpButton>
    </div>
  );
};
